<template>
  <v-row dense no-gutters>
    <v-col cols="12">
      <v-card class=" mt-1 fill-height">
        <v-tabs v-model="currTab" @change="tabChanged" class="fill-height">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab v-for="tab in tabs" :key="tab.key" :disabled="!project.ULF_ID && tab.key !== 'tabProject'"> {{ tab.label }} <v-icon small right> {{tab.icon}} </v-icon> </v-tab>
          <v-tab-item v-for="tab in tabs" :key="tab.key" >
            <component :is="tab.tab_component" :receipt="localReceipt" :activeTab="tabKey" @onChange="tab.onChangeHandler"></component>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
    <info-dialog :message="'Не задано имя проекта!'" v-model="infoShow"/>
  </v-row>
</template>

<script>
import { RCPT_CREATE_RECEPTURE, RCPT_UPDATE, RCPT_GET_COMPONENTS } from '@/store/actions/receptures'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import rcptResourcesCard from '@/components/modules/calcs/cards/rcptResourcesCard.vue'
import rcptLabDataPanel from '@/components/modules/calcs/panels/rcptLabDataPanel.vue'
import rcptPropertiesPanel from '@/components/modules/calcs/panels/rcptPropertiesPanel'
import rcptReportPanel from '@/components/modules/calcs/panels/rcptReportPanel.vue'
import ProjectDialogCard from '@/components/modules/projects/cards/receipes/projectDialogCard.vue'

export default {
  name: 'sysCalculationEditor',
  components: {
    rcptResourcesCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/calcs/cards/rcptResourcesCard'),
    rcptLabDataPanel: () => import(/* webpackChunkName: "project" */ '@/components/modules/calcs/panels/rcptLabDataPanel.vue'),
    rcptPropertiesPanel: () => import(/* webpackChunkName: "project" */ '@/components/modules/calcs/panels/rcptPropertiesPanel'),
    rcptReportPanel: () => import(/* webpackChunkName: "project" */ '@/components/modules/calcs/panels/rcptReportPanel'),
    InfoDialog: () => import(/* webpackChunkName: "commonUI" */ '@/components/common/dialogs/infoDialog.vue'),
    ProjectDialogCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/receipes/projectDialogCard')
  },
  data () {
    return {
      tabs: [
        { key: 'tabProject', tab_component: rcptResourcesCard, label: 'Ресурсы', icon: '', onChangeHandler: this.rcptDataChange },
        { key: 'tabProperties', tab_component: rcptLabDataPanel, label: 'Лаб. данные', icon: '', onChangeHandler: this.rcptDataChange },
        { key: 'tabComponents', tab_component: rcptPropertiesPanel, label: 'Параметры', icon: '', onChangeHandler: this.rcptDataChange },
        { key: 'tabCPCombined', tab_component: rcptReportPanel, label: 'Отчёт', icon: '', onChangeHandler: this.rcptDataChange },
        { key: 'tabDialog', tab_component: ProjectDialogCard, label: 'Переписка', icon: '', onChangeHandler: this.projectDialogChange }
      ],
      saveAction: { text: 'Сохранить рецептуру', actionType: 'Рецептура', action: 'saveRcpt', method: this.saveProject, icon: 'mdi-newspaper-plus', params: '' },
      updAction: { text: 'Обновить рецептуру', actionType: 'Рецептура', action: 'updRcpt', method: this.updProject, icon: 'mdi-newspaper-check', params: '' },
      closeViewer: { text: 'Завершить просмотр', actionType: 'Рецептура', action: 'closeRcptView', method: this.closeProject, icon: 'mdi-window-close', params: '' },
      localReceipt: {},
      currTab: 0,
      activeTab: '',
      infoShow: false
    }
  },
  computed: {
    project: {
      get () {
        return this.$store.getters.getCurrentRecepture
      }
    },
    receipt: {
      get () {
        return { ...this.$store.getters.getCurrentCalculation, ULF_NAME: this.project.ULF_NAME }
      }
    },
    tabKey: {
      get: function () {
        return this.tabs[this.currTab].key
      }
    }
  },
  watch: {
    project (val) {
      console.log('sysCalculationEditor:: watcher detected receipt changed', val)
      this.resetLocal()
    }
  },
  methods: {
    getComponents () {
      this.$store.dispatch(RCPT_GET_COMPONENTS, { ULF_UUID: this.localReceipt.ULF_UUID || null })
        .then((res) => {
          if (!this.localReceipt.COMPONENTS) this.localReceipt.COMPONENTS = []
          this.localReceipt.COMPONENTS.splice(0, this.localReceipt.COMPONENTS.length, ...res)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${err}` })
        })
        .finally(() => {
        })
    },
    resetLocal () {
      if (this.receipt && this.receipt.RCP_UUID) {
        console.log('sysCalculationEditor:: Cloning current recepture ', this.receipt)
        // eslint-disable-next-line no-undef
        this.localReceipt = structuredClone(this.receipt)
      } else {
        console.log('sysCalculationEditor:: Clearing current recepture')
        this.localReceipt = { ULF_UUID: this.project.ULF_UUID, ULF_NAME: this.project.ULF_NAME, COMPONENTS: [] }
      }
      this.getComponents()
      this.setActions()
    },
    tabChanged (val) {
      console.log('Current tab is ', this.currTab)
      this.setActions()
    },
    dataValid () {
      const clearName = this.localReceipt.RCP_NAME ? this.localReceipt.RCP_NAME.trim() : ''
      const nameOK = clearName.length > 0
      const seasonOK = this.localReceipt.SEASON_TYPE
      const stockRatioOK = this.localReceipt.STOCK_RATIO
      return nameOK && stockRatioOK && seasonOK
    },
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Рецептура', actions: [] })
      if (this.localReceipt.RCP_UUID) {
        if (this.dataValid()) this.$store.dispatch(UI_ADD_ACTION, this.updAction)
      } else {
        if (this.dataValid()) this.$store.dispatch(UI_ADD_ACTION, this.saveAction)
      }
      this.$store.dispatch(UI_ADD_ACTION, this.closeViewer)
    },
    saveProject () {
      console.log('sysCalculationEditor:: Trying to save', this.localReceipt)
      if (!this.dataValid()) {
        this.infoShow = true
        return
      }
      this.$store.dispatch(RCPT_CREATE_RECEPTURE, this.localReceipt)
        .then((resp) => {
          console.log('sysCalculationEditor:: Saved success ', resp)
          // this.$router.push({ path: '/projects/project', query: { reqid: self.currentProject.ULF_ID } })
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    },
    updProject () {
      console.log('sysCalculationEditor:: Trying to update', this.localReceipt)
      if (!this.dataValid()) {
        this.infoShow = true
        return
      }
      console.log('data is valid', this.localReceipt)
      this.$store.dispatch(RCPT_UPDATE, this.localReceipt)
        .then((resp) => {
          console.log('sysCalculationEditor:: Update success ', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    },
    closeProject () {
      console.log('sysCalculationEditor:: Trying to close')
      this.$router.push('/projects/mycalcs')
    },
    rcptDataChange (prj) {
      console.log('sysCalculationEditor:: rcptDataChange method called ', prj)
      if (this.currTab) {
        console.log('sysCalculationEditor:: rcptDataChange restructuring ', prj)
        // eslint-disable-next-line no-undef
        let tmp = structuredClone(this.localReceipt)
        tmp = { ...tmp, ...prj }
        this.localReceipt = tmp
      } else {
        console.log('sysCalculationEditor:: rcptDataChange flat change ', prj)
        this.localReceipt = { ...this.localReceipt, ...prj }
      }
      console.log('sysCalculationEditor:: rcptDataChange current data is ', this.localReceipt)
      this.setActions()
    },
    projectRouteChange (prj) {
      console.log('sysCalculationEditor:: projectRouteChange method called ', prj)
      this.setActions()
    },
    projectDialogChange (prj) {
      console.log('sysCalculationEditor:: projectDialogChange method called ', prj)
      this.setActions()
    },
    addRcptProperty () {
      console.log('addRcptProperty called')
    },
    updRcptProperty () {
      console.log('updRcptProperty called')
    },
    delRcptProperty () {
      console.log('delRcptProperty called')
    },
    addRcptComponent () {
      console.log('addRcptComponent called')
    },
    updRcptComponent () {
      console.log('updRcptComponent called')
    },
    delRcptComponent () {
      console.log('delRcptComponent called')
    }
  },

  mounted: function () {
    console.log('views::sysCalculationEditor:: mounted with project ', this.project, ' and recepture ', this.localReceipt)
    this.resetLocal()
  }
}
</script>
